export default __webpack_public_path__ + "static/media/auteuil11.fe48e2f8.jpg";